import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/fr'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)
dayjs.locale('fr')

export type DateBound = string | 'infinity' | null | undefined

const ERROR_MESSAGES = {
    belowMinToday: "La date saisie ne peut pas être inférieure à la date d'aujourd'hui",
    belowMin: 'La date saisie ne peut etre inférieure à la date du JJ/MM/AAAA',
    aboveMaxToday: "La date saisie ne peut pas être supérieure à la date d'aujourd'hui",
    aboveMax: 'La date saisie ne peut etre supérieure à la date du JJ/MM/AAAA',
}

export const parseRawDDMMYYYYToDayjs = (raw?: string | null): Dayjs | null => {
    if (!raw) return null
    const str = String(raw).trim()
    if (!str) return null
    const parsed = dayjs(str, 'DD/MM/YYYY', true)
    return parsed.isValid() ? parsed : null
}

export const formatDayjsDDMMYYYY = (d: Dayjs) => d.format('DD/MM/YYYY')

const isInfinity = (bound: DateBound) => typeof bound === 'string' && bound.toLowerCase() === 'infinity'

const isSameDayAsToday = (d: Dayjs) => d.isSame(dayjs(), 'day')

export const validateDateInRange = (
    raw: string | null | undefined,
    dateMin: DateBound,
    dateMax: DateBound
): { isValid: boolean; errorMessage?: string } => {
    const parsed = parseRawDDMMYYYYToDayjs(raw)
    if (!parsed) return { isValid: false }

    if (!isInfinity(dateMin)) {
        const minDate = parseRawDDMMYYYYToDayjs(String(dateMin))
        if (minDate && parsed.isBefore(minDate, 'day')) {
            return {
                isValid: false,
                errorMessage: isSameDayAsToday(minDate) ? ERROR_MESSAGES.belowMinToday : ERROR_MESSAGES.belowMin,
            }
        }
    }
    if (!isInfinity(dateMax)) {
        const maxDate = parseRawDDMMYYYYToDayjs(String(dateMax))
        if (maxDate && parsed.isAfter(maxDate, 'day')) {
            return {
                isValid: false,
                errorMessage: isSameDayAsToday(maxDate) ? ERROR_MESSAGES.aboveMaxToday : ERROR_MESSAGES.aboveMax,
            }
        }
    }
    return { isValid: true }
}
